import { createSignal, Show } from "solid-js";
import { Text, View, hexColor } from "@lightningtv/solid";
import { fontFamily, isRTL } from "../translations/configuration";

const C = { blue: "#2563eb", iconBg: "#1f2937" };

// Stage constants
const STAGE_W = 1920;
const LOGO_W = 270;
const LOGO_H = 82;
const ICON_W = 80;

const Header = (props: { screen?: string; ref?: (el: any) => void; onRight?: () => void; onDown?: () => void; onLeft?: () => void }) => {
    const [focused, setFocused] = createSignal(false);

    // Logo is centred horizontally regardless of direction.
    const logoX = () => Math.round((STAGE_W - LOGO_W) / 2); // ≈ 825

    // Screen-label area: in LTR it sits on the left (x=50),
    // in RTL it moves to the right (x=1500 with text) or far right if no screen.
    const labelAreaX = () => {
        if (isRTL()) return props.screen === "" ? 1700 : 1500;
        return 50;
    };

    // In LTR the layout is [ICON] [Text].
    // In RTL the layout is [Text] [ICON] — icon moves to the right of the text.
    const iconX = () => (isRTL() ? ICON_W + 180: 0);
    const textX = () => (isRTL() ? 0 : ICON_W + 10);

    return (
        <View
            ref={function (el: any) { if (props.ref) props.ref(el); }}
            height={120}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onEnter={() => history.back()}
            onDown={props.onDown}
            onRight={props.onRight}
            onLeft={props.onLeft}
        >
            {/* Centred logo */}
            <View
                src="https://i.ibb.co/ZVmDwNg/logo.png"
                x={logoX()}
                y={50}
                width={LOGO_W}
                height={LOGO_H}
            />

            {/* Screen label: icon + title */}
            <View x={labelAreaX()} y={50}>

                {/* Focus border ring */}
                <Show when={focused()}>
                    <View
                        x={iconX() - 2} y={-2}
                        width={84} height={84}
                        borderRadius={44}
                        color={hexColor(C.blue)}
                        zIndex={-1}
                    />
                </Show>

                {/* Icon circle */}
                <View
                    x={iconX()} y={0}
                    width={ICON_W} height={ICON_W}
                    borderRadius={40}
                    color={hexColor(C.iconBg)}
                >
                    <View x={0} y={0} src="https://i.ibb.co/LX13T2JW/Group-Live-Tv.png" width={ICON_W} height={ICON_W} />
                </View>
                <Text
                    x={10}
                    y={23}
                    fontSize={34}
                    style={{ fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily(), color: "white" }}
                >
                    {props.screen}
                </Text>
            </View>
        </View>
    );
};

export default Header;